import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { DynamicText } from "@/ui/DynamicText";
import { Button, Col, Row, Stack } from "react-bootstrap";
import { DynamicHtml } from "@/ui/DynamicHtml";
import classes from "./styles.module.scss";
import clsx from "classnames";
import ArrowRight from "@/assets/ArrowRight.svg";
import { useLink } from "@/hooks/useLink";
import { useRouter } from "next/router";

export const CulturePageBannerSection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  const route = useRouter();
  const isPageGravitasCulture = route.asPath === "/gravitas-culture";

  return (
    <Banner
      className={clsx(className, classes.banner)}
      title={<DynamicText path={`page.culture.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.culture.banner.image", src: "/assets/banners/culture.png" }}
      variant="quaternary"
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.culture.banner.text.${locale}`} />
          {isPageGravitasCulture ? (
            <Button href="/join-us/jobs" className="mt-3" variant="quinary">
              <DynamicText path={`page.culture.banner.button.${locale}`} />
              <ArrowRight className="ms-3" width={17} height={14} />
            </Button>
          ) : (
            <Button href={link("jobs")} className="mt-3" variant="quinary">
              <DynamicText path={`page.culture.banner.button.${locale}`} />
              <ArrowRight className="ms-3" width={17} height={14} />
            </Button>
          )}
        </Col>
      </Row>
    </Banner>
  );
};
